import React, { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }
    let timer;
    const poll = async () => {
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          navigate(`/orders/${data.order_number}`, { replace: true });
          return;
        }
        if (["failed", "expired"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch (e) {}
      if (attempts.current >= 12) { setStatus("timeout"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [params, navigate]);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center px-6 text-center">
      {status === "checking" && (
        <>
          <Loader2 size={40} className="animate-spin text-[#D4AF37]" />
          <p className="mt-5 font-display text-2xl text-white uppercase">Confirming Your Order…</p>
          <p className="text-zinc-400 text-sm mt-1">Hang tight — this only takes a moment.</p>
        </>
      )}
      {(status === "error" || status === "timeout") && (
        <>
          <p className="font-display text-3xl text-white uppercase">{status === "timeout" ? "Still Processing" : "Payment Unsuccessful"}</p>
          <p className="text-zinc-400 text-sm mt-2 max-w-sm">{status === "timeout" ? "Your payment is taking longer than usual. Check your email for confirmation shortly." : "We couldn't confirm your payment. No tickets were issued."}</p>
          <button onClick={() => navigate("/events")} className="btn-gold mt-6 rounded-md px-6 py-3 font-oswald tracking-widest text-sm">BACK TO EVENTS</button>
        </>
      )}
    </div>
  );
}
